import { checkRectangleIntersection } from "./checkRectangleIntersection";

export function getEmptyAdjacentRectangles(
  placedRectangles,
  refRectangleIndex,
  containerWidth,
  containerHeight
) {
  if (placedRectangles.length === 0) {
    return [[0, 0, containerWidth, containerHeight]];
  }

  if (refRectangleIndex > placedRectangles.length) {
    return [];
  }

  const [x1, y1, x2, y2] = placedRectangles[refRectangleIndex];
  const xAxisIntervals = [[x1, x2]];

  if (x1 > 0) {
    xAxisIntervals.unshift([0, x1]);
  }

  if (x2 < containerWidth) {
    xAxisIntervals.push([x2, containerWidth]);
  }

  const yAxisIntervals = [[y1, y2]];

  if (y1 > 0) {
    yAxisIntervals.unshift([0, y1]);
  }

  if (y2 < containerHeight) {
    yAxisIntervals.push([y2, containerHeight]);
  }

  const emptyRectangles = [];
  const rectangleHitArray = [];

  // Hit Array Initilization
  for (let i = 0; i < xAxisIntervals.length; i++) {
    rectangleHitArray.push([]);

    for (let j = 0; j < yAxisIntervals.length; j++) {
      const rectangle = [
        xAxisIntervals[i][0],
        yAxisIntervals[j][0],
        xAxisIntervals[i][1],
        yAxisIntervals[j][1],
      ];

      rectangleHitArray[i].push({ rectangle, hit: false });
    }
  }

  // Hit detection
  for (let i = 0; i < xAxisIntervals.length; i++) {
    for (let j = 0; j < yAxisIntervals.length; j++) {
      const rectangle = rectangleHitArray[i][j].rectangle;

      for (const placedRectangle of placedRectangles) {
        if (checkRectangleIntersection(rectangle, placedRectangle)) {
          rectangleHitArray[i][j].hit = true;
          break;
        }
      }
    }
  }

  // Vertical join scan
  for (let i = 0; i < xAxisIntervals.length; i++) {
    let join = true;
    const seperate = [];

    for (let j = 0; j < yAxisIntervals.length; j++) {
      if (rectangleHitArray[i][j].hit === true) {
        join = false;
      } else {
        seperate.push(rectangleHitArray[i][j].rectangle);
      }
    }

    if (join) {
      emptyRectangles.push([
        rectangleHitArray[i][0].rectangle[0],
        rectangleHitArray[i][0].rectangle[1],
        rectangleHitArray[i][yAxisIntervals.length - 1].rectangle[2],
        rectangleHitArray[i][yAxisIntervals.length - 1].rectangle[3],
      ]);
    } else {
      emptyRectangles.concat(seperate);
    }
  }

  // Horizontal join scan
  for (let j = 0; j < yAxisIntervals.length; j++) {
    let join = true;
    const seperate = [];

    for (let i = 0; i < xAxisIntervals.length; i++) {
      if (rectangleHitArray[i][j].hit === true) {
        join = false;
      } else {
        seperate.push(rectangleHitArray[i][j].rectangle);
      }
    }

    if (join) {
      emptyRectangles.push([
        rectangleHitArray[0][j].rectangle[0],
        rectangleHitArray[0][j].rectangle[1],
        rectangleHitArray[xAxisIntervals.length - 1][j].rectangle[2],
        rectangleHitArray[xAxisIntervals.length - 1][j].rectangle[3],
      ]);
    } else {
      emptyRectangles.concat(seperate);
    }
  }

  return emptyRectangles;
}
